import { render } from "./aluno-historico.vue?vue&type=template&id=2766d6c2&scoped=true"
import script from "./aluno-historico.vue?vue&type=script&lang=js"
export * from "./aluno-historico.vue?vue&type=script&lang=js"

import "./aluno-historico.vue?vue&type=style&index=0&id=2766d6c2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2766d6c2"]])

export default __exports__